/**
 * User-visible conversation titles (shell_metadata.title on the backend).
 */

export function buildDefaultConversationTitle(agentOrScopeName: string, at: Date = new Date()): string {
  const label = (agentOrScopeName || 'Agent').trim() || 'Agent';
  const stamp = at.toISOString().replace('T', ' ').slice(0, 19);
  return `${label} - ${stamp}`;
}

export function readConversationTitle(
  shellMetadata: Record<string, unknown> | null | undefined,
  fallbackName?: string | null
): string {
  if (shellMetadata && typeof shellMetadata['title'] === 'string') {
    const trimmed = shellMetadata['title'].trim();
    if (trimmed) return trimmed;
  }
  if (fallbackName?.trim()) return fallbackName.trim();
  return '';
}
